<template>
    <div class="list-switch-btn" @click="switchList"></div>
</template>

<script>
import _ from '../../config/util'
import { Toast } from 'mint-ui'
export default {
    name: 'MyLocation',
    methods: {
        switchList() {
            const map = this.$store.state.mapObj
            const userLocationMarker = this.$store.state.userLocationMarker
            // 获取当前地图的限制区域
            const limtBounds = map.getLimitBounds()
            // 获取用户当前位置
            _.geolocation().then(res => {
                const amapLngLat = new AMap.LngLat(res.longitude, res.latitude)
                if (limtBounds) {
                    // 判断是否在景区范围内
                    if (limtBounds.contains(amapLngLat)) {
                        console.log('手动定位', userLocationMarker)
                        if (userLocationMarker == '') {
                            // 自定义标记点
                            const content =
                                '<div class="custor-marker"><div class="user-photo"></div></div>'
                            const marker = new AMap.Marker({
                                content: content,
                                position: [res.longitude, res.latitude],
                                offset: new AMap.Pixel(-40, -80),
                                map: map
                            })
                            this.$store.commit('setUserLocationMarker', marker)
                        } else {
                            userLocationMarker.setPosition(amapLngLat)
                        }
                        // 将地图移动到用户的位置
                        map.panTo(amapLngLat)
                    } else {
                        if(window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger') Toast(this.$t('main["当前不在景区范围内！"]'))
                    }
                } else {
                    if (userLocationMarker == '') {
                        // 自定义标记点
                        const content =
                            '<div class="custor-marker"><div class="user-photo"></div></div>'
                        const marker = new AMap.Marker({
                            content: content,
                            position: [res.longitude, res.latitude],
                            offset: new AMap.Pixel(-40, -80),
                            map: map
                        })
                        this.$store.commit('setUserLocationMarker', marker)
                    } else {
                        userLocationMarker.setPosition(amapLngLat)
                    }
                    // 将地图移动到用户的位置
                    map.panTo(amapLngLat)
                }
            })
        }
    }
}
</script>

<style lang='scss' scoped>
.list-switch-btn {
    position: fixed;
    bottom: 0.5rem;
    right: 0.3rem;
    z-index: 191;
    margin-top: 0.1rem;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    background: #fff url(../../assets/location_icon_1.png) no-repeat center
        center / 0.4rem 0.4rem;
    box-shadow: 0 0 0.2rem rgba($color: #5b7a17, $alpha: 0.75);
}
</style>
